module.exports = __webpack_public_path__ + "img/dots.538b3158.png";